import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../i18n';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const HEARD_KEYS = ['Instagram', 'Facebook', 'Google', 'Referral', 'Driving By', 'TikTok', 'Other'];

export default function LeadForm() {
  const navigate = useNavigate();
  const { t } = useLang();
  const [form, setForm] = useState({ full_name: '', email: '', heard_from: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const heardLabels = {
    Instagram: 'Instagram',
    Facebook: 'Facebook',
    Google: 'Google',
    Referral: t.leadHeardReferral,
    'Driving By': t.leadHeardDrivingBy,
    TikTok: 'TikTok',
    Other: t.leadHeardOther,
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.full_name.trim() || !form.email.trim() || !form.heard_from) {
      setError(t.leadError);
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/api/leads`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Submission failed');
      navigate('/thank-you');
    } catch {
      setError(t.leadErrorGeneric);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="lead-form-section" data-testid="lead-form-section">
      <div className="sm-container">
        <div className="lead-form-card" data-testid="lead-form-card">
          <div className="lead-form-header">
            <h2 className="lead-form-title" data-testid="lead-form-title">{t.leadTitle}</h2>
            <p className="lead-form-subtitle">
              {t.leadSubtitle2.split('\n').map((line, i) => (
                <span key={i}>{line}{i === 0 ? <br /> : ''}</span>
              ))}
            </p>
          </div>
          <form onSubmit={handleSubmit} className="lead-form" data-testid="lead-form">
            <div className="lead-field">
              <label htmlFor="full_name">{t.leadName}</label>
              <input id="full_name" name="full_name" type="text" placeholder={t.leadNamePlaceholder} value={form.full_name} onChange={handleChange} required data-testid="lead-form-name" />
            </div>
            <div className="lead-field">
              <label htmlFor="email">{t.leadEmail}</label>
              <input id="email" name="email" type="email" placeholder={t.leadEmailPlaceholder} value={form.email} onChange={handleChange} required data-testid="lead-form-email" />
            </div>
            <div className="lead-field">
              <label htmlFor="heard_from">{t.leadHeard}</label>
              <select id="heard_from" name="heard_from" value={form.heard_from} onChange={handleChange} required data-testid="lead-form-heard">
                <option value="" disabled>{t.leadHeardPlaceholder}</option>
                {HEARD_KEYS.map((key) => (
                  <option key={key} value={key}>{heardLabels[key]}</option>
                ))}
              </select>
            </div>
            {error && <p className="lead-form-error" data-testid="lead-form-error">{error}</p>}
            <button type="submit" className="btn-primary btn-lg lead-form-submit" disabled={submitting} data-testid="lead-form-submit">
              {submitting ? t.leadSending : t.leadSubmit}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
